import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { ClearButton, Divider, Input, InputActions, InputContent, InputContentText, InputPlaceholder, Label, OptionItem, OptionList, SelectWrapper } from "./styles";

const SelectV2 = ({
  id,
  name,
  label,
  value,
  options,
  isMulti = false,
  onChange,
  isClearable = false,
  isDisabled = false,
  isLoading = false,
  placeholder = "Seleccionar...",
}) => {
  const [open, setOpen] = useState(false);

  const handleOptionClick = (option) => {
    let newValue;
    let action;

    if (isMulti) {
      const exists = value && value.some((v) => v.value === option.value);
      if (exists) {
        newValue = value.filter((v) => v.value !== option.value);
        action = "deselect-option";
      } else {
        newValue = [...(value || []), option];
        action = "select-option";
      }
    } else if (value && value.value === option.value) {
      newValue = null;
      action = "clear";
    } else {
      newValue = option;
      action = "select-option";
    }

    onChange(newValue, {
      action,
      name,
      option: isMulti ? option : undefined,
      removedValues: (isMulti && value && value.filter((v) => v.value === option.value)) || [value],
    });
    setOpen(false);
  };
  const handleClear = () => {
    const previous = value;
    onChange(isMulti ? [] : null, {
      action: "clear",
      name,
      removedValues: isMulti ? previous : [previous],
    });
  };

  const isSelected = (option) => (isMulti ? value && value.some((v) => v.value === option.value) : value && value.value === option.value);

  let displayValue = "";

  if (isMulti && Array.isArray(value) && value.length > 0) {
    const [first, ...rest] = value;
    displayValue = first.label;
    if (rest.length > 0) {
      displayValue += ` (+${rest.length})`;
    }
  } else if (!isMulti && value) {
    displayValue = value.label;
  }

  return (
    <SelectWrapper>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Input name={name} onClick={() => !isDisabled && setOpen((prev) => !prev)}>
        {(value && !isMulti && value !== "") || (isMulti && value && value.length && value !== "") ? (
          <InputContent>
            <InputContentText>{displayValue}</InputContentText>

            {isClearable && value && (
              <ClearButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleClear();
                }}
              >
                ✕
              </ClearButton>
            )}
          </InputContent>
        ) : (
          <InputPlaceholder>{placeholder}</InputPlaceholder>
        )}

        <InputActions>
          <Divider>
            <ChevronDown color="#cccccc" size={16} />
          </Divider>
        </InputActions>
      </Input>

      {open && !isDisabled && !isLoading && (
        <OptionList>
          {[...options]
            .sort((a, b) => {
              const aSelected = isSelected(a);
              const bSelected = isSelected(b);
              if (aSelected === bSelected) return 0;
              return aSelected ? -1 : 1;
            })
            .map((opt) => (
              <OptionItem key={opt.value} selected={isSelected(opt)} onClick={() => handleOptionClick(opt)}>
                {opt.label}
                {isSelected(opt) && <span>✔</span>}
              </OptionItem>
            ))}
        </OptionList>
      )}
    </SelectWrapper>
  );
};

export default SelectV2;
